import React from "react"
import { css } from "@emotion/core"
import t, { mixin } from "theme"
import LoadWithAuth from "components/UI/LoadWithAuth"
import PasswordlessBox from "components/Auth/PasswordlessBox"

const SignUpBox = ({ ...props }) => {
    return (
        <div {...props}>
            <LoadWithAuth
                signedOut={
                    <div
                        css={css`
                            ${mixin.tabletandphonestyle} {
                                padding: ${t.space[3]};
                                margin: ${t.space[5]} 0;
                                background-color: ${t.color.light};
                                text-align: center;
                            }
                        `}>
                        <div
                            css={css`
                                width: 100%;
                                margin-bottom: ${t.space[2]};
                            `}>
                            Join our newsletter to
                            <br />
                            <b>NEVER MISS AN UPDATE!</b>
                        </div>
                        <PasswordlessBox
                            flex
                            inputStyle={css`
                                border-radius: 2px 0px 0px 2px;
                                width: 60%;
                            `}
                            buttonStyle={css`
                                position: relative;
                                left: -1px;
                                width: 40%;
                                padding: ${t.space[1]} ${t.space[2]};
                                border-radius: 0px 2px 2px 0px;
                            `}
                        />
                    </div>
                }
            />
        </div>
    )
}

export default SignUpBox
